import React from 'react';
import queryString from 'query-string'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import BarcodeReader from 'react-barcode-reader'
import CssBaseline from "@material-ui/core/CssBaseline";
import MiniDrawer from "../navigation/DrawerMenu";
import Grid from "@material-ui/core/Grid";
import StockMenu from "../navigation/stock/topbar";
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import MuiAlert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import Paper from '@material-ui/core/Paper'
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigatePrevIcon from '@material-ui/icons/NavigateBefore';
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import {StockService} from '../../_services/stock.service'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import { Switch as ConditionalSwitch, Case, Default } from 'react-if'
import { Warehouse } from "../../_helpers/auth-header";
import ImageWithStatus from "../../components/ImageWithStatus";

const styles = theme => ({
    root: {
        minWidth: 275,
    },

    mainGrid: {
        width: '100vw',
        height: '100vh',
        spacing: 0,
        justify: 'space-around'
    },

    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },

});

function setTabSelectedId(delta) {
    console.log(delta);
    return (previousState, currentProps) => {
        return { ...previousState, selectedId: delta };
    };
}

class LotDetail extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            checked:true,
            selectedId:-1,
            alertmessage:"",
            open: false,
            confirmOpen:false,
            result: 'No result',
            checkedBarcodeProblem: false,
            itemStatus: this.props.match.params.itemstatus,
            data:{},
            previousId: 0,
            nextId: 0,
            validBarcodeScanned:false,
            hasPrevious: false,
            hasNext: false,
            id: this.props.match.params.id,
            amount : 0,
            remarks: ""
        };

        console.log(this.state.itemStatus);
        if(this.state.itemStatus === "todo")
           // this.setState(setTabSelectedId(0));
            this.state.selectedId = 0;


        console.log(this.state.selectedId);

        if(this.props.match.params.itemstatus == 'tocheck')
            this.state.selectedId = 1;


        if(this.props.match.params.itemstatus == 'tosend')
            this.state.selectedId = 2;

        if(this.props.match.params.itemstatus == 'sent')
            this.state.selectedId = 3;

        if(this.props.match.params.itemstatus == 'rejected')
            this.state.selectedId = 4;

        this.fetchData = this.fetchData.bind(this)
        this.handleScan = this.handleScan.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.handleConfirmCloseYes = this.handleConfirmCloseYes.bind(this);
        this.handleConfirmCloseNo = this.handleConfirmCloseNo.bind(this);
        this.handleRefuseConfirm = this.handleRefuseConfirm.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.fadeIn= this.fadeIn.bind(this);
    }

    componentDidMount()
    {

        this.fetchData(this.state.id, this.state.itemStatus);


    }

    fetchData(id, state) {
        StockService.fetchData(id,state)
            .then(response => response.json())
            .then(({ data, previousId, nextId, hasPrevious, hasNext }) => {
                if(data)
                {    this.setState({
                    data: data,
                    previousId: previousId,
                    nextId: nextId,
                    hasPrevious: hasPrevious,
                    hasNext: hasNext,
                    checkedBarcodeProblem : false, validBarcodeScanned:false,
                    amount : data.quantity,
                    remarks: data.remarks
                });
                    const values = queryString.parse(this.props.location.search)
                    if(values.scanned === "1") // "top"
                    {
                        this.setState({validBarcodeScanned:true});}
                }
                else
                    this.props.history.push(`/stock/transfers/${this.state.itemStatus}`);
            });
    }
    fadeIn()
    {
        if(!this.state.checked)
        {
            this.setState({checked:true});
        }
    }
    getDetails(id)
    {
        this.setState({checked:false});
        this.fetchData(id, this.state.itemStatus);
        this.props.history.push(`/stock/transfers/${this.state.itemStatus}/detail/${id}`);
    }

    handleRefuseConfirm()
    {

        this.setState({dialogAction:'refuse', dialogDescription:"Bent u zeker dat u dit artikel wilt weigeren?", dialogTitle: "Artikel weigeren",confirmOpen:true});
    }

    handleResetConfirm()
    {
        this.setState({dialogAction:'reset', dialogDescription:"Bent u zeker dat u dit artikel opnieuw wil verwerken?", dialogTitle: "Artikel terug naar verwerken",confirmOpen:true});
    }

    handleConfirmCloseYes = (event) => {
        console.log("yes");
        this.setState({confirmOpen:false});
        if(this.state.dialogAction == 'refuse')
        {
            this.handleRefuse(this.state.data.id);
        }
        if(this.state.dialogAction == 'reset')
        {
            this.handleReset(this.state.data.id);
        }

    };

    handleConfirmCloseNo = (event) => {
        console.log("no");
        this.setState({confirmOpen:false});
    };

    handleClose = (event, reason) => {

        if(this.state.severity === "error")
        {
            this.setState({open:false});
        }
        else {
        if (reason === 'clickaway') {
            if(this.state.hasNext)
                this.getDetails(this.state.nextId);
            else
                this.props.history.push(`/stock/transfers/${this.state.itemStatus}`);
            return;
        }
        this.setState({open:false});
        if(this.state.hasNext)
            this.getDetails(this.state.nextId);
        else
            this.props.history.push(`/stock/transfers/${this.state.itemStatus}`);
        }
    };

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleChangeCheckedBarcodeProblem(){
        this.setState({ checkedBarcodeProblem : !this.state.checkedBarcodeProblem });
    };
    handleScan(data){
        this.setState({
            result: data,
            validBarcodeScanned: data.slice(0, -1) == this.state.data.barcode.slice(0, -1)
        })
        if(!this.state.validBarcodeScanned)
        {
            this.setState({alertmessage:"Ongeldige barcode - gescande code : " + data.slice(0, -1) + " - vereiste code : " + this.state.data.barcode.slice(0, -1) ,severity:"error", open:true});
        }
        else {
            if(this.state.itemStatus === "todo")
            {
                this.handleAccept(this.state.data.id);
            }
            if(this.state.itemStatus === "tocheck")
            {
                this.handleVerify(this.state.data.id);
            }

        }

    }
    handleError(err){
        console.error(err)
    }
    handleRefuse(id)
    {
        StockService.refuse(id, +this.state.amount, this.state.remarks)
        .then(result => {
            // login successful if there's a user in the response
            if (result === 'success') {
                this.setState({alertmessage:"Artikel werd geweigerd",severity:"success", open:true});
            }

            return result;
        });
    }
    handleAccept(id)
    {
        StockService.accept(id, +this.state.amount, this.state.remarks)
        .then(result => {
            // login successful if there's a user in the response
            if (result === 'success') {
                this.setState({alertmessage:"Artikel werd geaccepteerd",severity:"success", open:true});
            }
            return result;
        });
    }
    handleVerify(id)
    {
        StockService.verify(id, +this.state.amount, this.state.remarks)
            .then(result => {
                // login successful if there's a user in the response
                if (result === 'success') {
                    this.setState({alertmessage:"Artikel werd gecontroleerd",severity:"success", open:true});
                }
                return result;
            });
    }
    handleReset(id)
    {
        StockService.reset(id, +this.state.amount, this.state.remarks)
            .then(result => {
                // login successful if there's a user in the response
                if (result === 'success') {
                    this.setState({alertmessage:"Artikel werd teruggezet naar te verwerken",severity:"success", open:true});
                }
                return result;
            });
    }
    render(){
        const result = this.state.result;
        const { classes } = this.props;
        return (
            <React.Fragment>
                <CssBaseline />
                <MiniDrawer title={" - Transfer tussen winkels vanuit " + Warehouse()}>


                    <Grid className={classes.root.mainGrid}>
                        <StockMenu selectedId={this.state.selectedId}>
                            <BarcodeReader
                                onError={this.handleError}
                                onScan={this.handleScan}
                            />
                            <Snackbar
                                open={this.state.open}
                                onClose={()=>{this.handleClose()}}
                                autoHideDuration={3000}
                            >
                                <Alert onClose={()=>{this.handleClose()}} severity={this.state.severity}>
                                    {this.state.alertmessage}
                                </Alert>
                            </Snackbar>

                            <Dialog
                                open={this.state.confirmOpen}
                                onClose={()=>{this.handleConfirmCloseNo()}}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">

                                        {this.state.dialogDescription}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={()=>{this.handleConfirmCloseNo()}} color="primary">
                                        Nee
                                    </Button>
                                    <Button onClick={()=>{this.handleConfirmCloseYes()}} color="primary" autoFocus>
                                        Ja
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Grid container spacing={2} >
                                <Grid item xs={1}>
                                    {this.state.hasPrevious && <Button onClick={() => { this.getDetails(this.state.previousId); }}><NavigatePrevIcon/></Button>}
                                </Grid>

                                <Grid item xs={10}>
                                    <Fade in={this.state.checked} onExited={() => this.fadeIn()}>

                                        {this.state.data && <Paper style={{height:'60vh'}}>
                                    <Grid container spacing={2}  style={{height:'60vh'}} >
                                        <Grid item xs={2}>
                                            <ImageWithStatus imageUrl={this.state.data.imageUrl} key={this.state.data.sku}  />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography variant="h6">{this.state.data.description}</Typography><br/>
                                            <Grid container spacing={1} >
                                                <Grid item xs={5}>
                                                    Artikel groep
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <strong>{this.state.data.articleGroup}</strong>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    Artikel code
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <strong>{this.state.data.articleCode}</strong>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    Prijs
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <strong>€ {this.state.data.price}</strong>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    Maat
                                                </Grid>
                                                <Grid item xs={7} >
                                                    <strong style={{fontSize:'2em'}}>{this.state.data.articleSize}</strong>
                                                </Grid>

                                                <Grid item xs={5}>
                                                    Aantal
                                                </Grid>
                                                 <Grid item xs={7}>
                                                        <strong style={{fontSize:'2em'}}>{this.state.data.quantity}</strong>
                                                 </Grid>

    <Grid item xs={5}>
    Barcode (voor tests)
    </Grid>
    <Grid item xs={7}>
    <strong style={{ fontSize: '.8em' }}>{this.state.data.barcode}</strong>
    </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={5}>

                                            <Grid container spacing={1} >
                                                <Grid item xs={12}>
                                                   <Typography variant="h5"> <LocalShippingIcon  /> {this.state.data.toStore}</Typography><br/>
                                                </Grid>
                                                <Grid item item xs={11}>
                                                    <TextField
                                                        id="outlined-textarea"
                                                        label="Opmerkingen"
                                                        placeholder="Opmerkingen"
                                                        multiline="true"
                                                        rows="3"
                                                        fullWidth="true"
                                                        variant="outlined"
                                                        name="remarks"
                                                        value={this.state.remarks}
                                                        onChange={this.handleChange}
                                                    />
                                                </Grid>
                                                {this.state.data.quantity>0 &&
                                                <Grid item item xs={12}>
                                                <TextField id="Amount" label="Hoeveelheid" variant="outlined" value={this.state.amount}
                                                      name="amount"

                                                           onChange={this.handleChange}
                                                /></Grid>}
                                                <Grid item xs={12}>
                                                    <ConditionalSwitch>
                                                        <Case condition={ this.state.itemStatus === "todo" }>
                                                            <Switch
                                                                checked={this.state.checkedBarcodeProblem}
                                                                onChange={() => { this.handleChangeCheckedBarcodeProblem();}}
                                                                value="checkedA"
                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                            /><br/>
                                                            <Button variant="contained" onClick={() => { this.handleAccept(this.state.data.id);}} color="primary" disabled={!this.state.checkedBarcodeProblem && !this.state.validBarcodeScanned}>Verwerkt</Button>
                                                            <Button variant="contained" onClick={() => { this.handleRefuseConfirm();}} >
                                                                Weigeren
                                                            </Button>
                                                        </Case>
                                                        <Case condition={ this.state.itemStatus === "tocheck" }>
                                                            <Switch
                                                                checked={this.state.checkedBarcodeProblem}
                                                                onChange={() => { this.handleChangeCheckedBarcodeProblem();}}
                                                                value="checkedA"
                                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                            /><br/>
                                                            <Button variant="contained" onClick={() => { this.handleVerify(this.state.data.id);}} color="primary" disabled={!this.state.checkedBarcodeProblem && !this.state.validBarcodeScanned}>Gecontroleerd</Button>
                                                            <Button variant="contained" onClick={() => { this.handleRefuseConfirm();}} >
                                                                Weigeren
                                                            </Button>
                                                        </Case>
                                                        <Case condition={ this.state.itemStatus === "tosend" }>
                                                            <Button variant="contained" onClick={() => { this.handleRefuseConfirm();}} >
                                                                Weigeren
                                                            </Button>
                                                        </Case>
                                                        <Case condition={ this.state.itemStatus === "rejected" }>
                                                            <Button variant="contained" onClick={() => { this.handleResetConfirm();}} color="primary"  >
                                                                Opnieuw verwerken
                                                            </Button>
                                                        </Case>
                                                        <Default>

                                                        </Default>
                                                    </ConditionalSwitch>


                                                </Grid>
                                            </Grid>




                                            <br/>








                                        </Grid>
                                    </Grid>
                                    </Paper>}

                                    </Fade>
                                </Grid>
                                <Grid item xs={1}>
                                    {this.state.hasNext && <Button  onClick={() => { this.getDetails(this.state.nextId); }}><NavigateNextIcon/></Button>}
                                </Grid>
                            </Grid>




                        </StockMenu>




                    </Grid>
                </MiniDrawer>

            </React.Fragment>
        );
    }
}

LotDetail.propTypes = {
    classes: PropTypes.object.isRequired,
};
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default withStyles(styles)(LotDetail);
